// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from '@router'
import store from '@store'
import apiHelper from '@api/helper'
import Vuetify from 'vuetify'
import moment from 'moment'
import App from '@views/App'
import { convertDate, formatDate } from '@utils/datehelper'
import { downloadFile } from '@utils/downloadhelper'
import VueUploadComponent from 'vue-upload-component'
import msalGlobal from '@api/msal'


// css
import 'vuetify/dist/vuetify.min.css'
import '@scss/fepmtbutton.scss'
Vue.config.productionTip = false
Vue.use(Vuetify)
// Setup global $api reference so it's accessible from every Vue component
Vue.prototype.$api = apiHelper
Vue.prototype.$msal = msalGlobal 
Vue.prototype.$formatDate = formatDate
Vue.prototype.$convertDate = convertDate
Vue.prototype.$moment = moment
Vue.prototype.$downloadFile = downloadFile
Vue.component('file-upload', VueUploadComponent)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
